import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { getAllHolidays } from '../../services/companyHolidayService';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '90%',
    display: 'flex',
    justifyContent: 'center',
    margin: '20px auto',
  },
  card: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
}));

const staticData = [
  { id: 1, name: 'New Year', date: '2023-01-01' },
  { id: 2, name: 'Independence Day', date: '2023-07-04' },
  { id: 3, name: 'Christmas', date: '2023-12-25' },
  // Add more static data as needed
];

export default function HolidayListPage() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [holidayList, setHolidayList] = useState([]);

  useEffect(() => {
    setHolidayList(staticData);
    fetchHolidayData();
  }, []);

  const fetchHolidayData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllHolidays();
      setHolidayList(response?.data?.data?.rows || []);
      toast.success(response?.message);
    } catch (error) {
      toast.error(error);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Grid container className={classes.container}>
      {holidayList?.map((holiday) => (
        <Grid item xs={12} sm={6} md={4} key={holiday.id}>
          <Card className={classes.card}>
            <CardContent>
              <Typography variant="h5" component="div">
                {holiday.name}
              </Typography>
              <Typography variant="body2">Date: {format(new Date(holiday.date), 'dd-MMM-yyyy')}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
